import { z } from 'zod';
export const PublishedSipRouteKeySchema = z
    .object({
    organizationId: z.string().uuid(),
    configVersion: z.number().int().nonnegative(),
    agentReference: z.string().min(1).max(200),
})
    .strict();
export const PublishedSipRouteSchema = PublishedSipRouteKeySchema.extend({
    projectId: z.string().uuid(),
    provisionReference: z.string().uuid(),
    state: z.enum(['unknown', 'ready']),
    resourceReference: z.string().nullable(),
}).strict();
export const ReservePublishedSipRouteResponseSchema = z
    .object({
    route: PublishedSipRouteSchema,
    /** Deprecated legacy response; reservation is not integration submission authority. */
    mayCreate: z.boolean().optional(),
})
    .strict();
export const CompletePublishedSipRouteSchema = PublishedSipRouteKeySchema.extend({
    provisionReference: z.string().uuid(),
    resourceReference: z.string().min(1).max(200),
}).strict();
export const PendingTelephonePublicationsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(25),
    after: z.string().uuid().optional(),
});
export const PendingTelephonePublicationSchema = PublishedSipRouteKeySchema.extend({
    projectId: z.string().uuid(),
});
export const PendingTelephonePublicationsResponseSchema = z.object({
    items: z.array(PendingTelephonePublicationSchema),
});
//# sourceMappingURL=PublishedSipRoute.js.map